import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRoutes from './routes/auth-route';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { GoogleMapsProvider } from './context/GoogleMapsContext';

import IdleScreen from './components/base/idle-screen';
import { useResourceStore } from './store';
declare global {
  interface Window {
    __GOOGLE_MAPS_API_KEY__?: string;
  }
}

const App: React.FC = () => {
  window.__GOOGLE_MAPS_API_KEY__ = 'AIzaSyBYBagLn3rEQXua-s41FsX0UG4v4GcRkfM';
  const { getUserIpLocationData } = useResourceStore();

  useEffect(() => {
    getUserIpLocationData();
  }, []);

  return (
    <>
      {' '}
      <GoogleMapsProvider>
        <Router>
          <AppRoutes />
          <IdleScreen />
        </Router>
        <div>
          <Toaster
            position="top-right"
            toastOptions={{
              success: {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  border: '1px solid #D4E7FF',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                  borderRadius: '12px',
                  padding: '12px 16px',
                  color: '#333',
                  backgroundColor: '#FFFFFF',
                },
                iconTheme: {
                  primary: '#4285F4',
                  secondary: '#FFFFFF',
                },
              },
            }}
          >
            {(t) => (
              <ToastBar toast={t}>
                {({ icon, message }) => (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      maxWidth: '450px', // Limit the maximum width
                      width: '100%', // Allow responsiveness
                      wordWrap: 'break-word', // Ensure long text wraps
                      wordBreak: 'break-word', // Break long words
                      overflow: 'hidden', // Prevent overflow
                    }}
                  >
                    <div
                      style={{
                        width: '36px',
                        height: '36px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: '#E3F2FD',
                        borderRadius: '50%',
                        flexShrink: 0, // Prevent shrinking of the icon
                      }}
                    >
                      {icon}
                    </div>
                    <div
                      style={{
                        flex: 1, // Take available space for the message
                        overflow: 'hidden', // Prevent overflow
                        textOverflow: 'ellipsis', // Add ellipsis for long text
                        whiteSpace: 'nowrap', // Keep text on one line
                      }}
                    >
                      {/* Render message properly */}
                      <div style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {typeof message === 'string'
                          ? message
                          : message && React.isValidElement(message)
                            ? message
                            : ''}
                      </div>
                    </div>
                    {t.type !== 'loading' && (
                      <button
                        style={{
                          border: 'none',
                          backgroundColor: 'transparent',
                          color: '#888',
                          cursor: 'pointer',
                          fontSize: '16px',
                          marginLeft: 'auto',
                          flexShrink: 0, // Prevent shrinking of the button
                        }}
                        onClick={() => toast.dismiss(t.id)}
                      >
                        ✕
                      </button>
                    )}
                  </div>
                )}
              </ToastBar>
            )}
          </Toaster>
        </div>
      </GoogleMapsProvider>
    </>
  );
};

export default App;
